module.exports = "/_next/static/images/Error@3x-c70e64d8bd1d8f1c5914f2e04a0c3812.png";